export const PROGRAMME_OPTIONS = [
    "ICA Three-year Advanced Culinary Arts, Advanced Patisserie & Specialist Culinary Field",
    "ICA Three-year Advanced Culinary Arts, Advanced Patisserie",
    "ICA Two-year Culinary Arts & Advanced Patisserie",
];

export const POE_SCALE = [
    { score: 3, label: "No evidence" },
    { score: 4, label: "Way below expectations" },
    { score: 5, label: "Displays some evidence but requires more work" },
    { score: 6, label: "Meet and satisfies the standards required" },
    { score: 7, label: "Above the required standards" },
    { score: 8, label: "Excels and exceed all expectations" },
];
